interface ChipToggleProps {
    label: string;
    active: boolean;
    onClick: () => void;
}

export function ChipToggle({ label, active, onClick }: ChipToggleProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="chip"
            style={{
                background: active ? 'var(--lm-dark-marine)' : '#fff',
                color: active ? '#fff' : 'var(--lm-dark-marine)',
                borderColor: active ? 'var(--lm-dark-marine)' : 'var(--lm-gray-2)',
                cursor: 'pointer'
            }}
        >
            {label}
        </button>
    );
}

interface ChipMultiSelectProps {
    options: string[];
    value: string[];
    onChange: (value: string[]) => void;
}

export function ChipMultiSelect({ options, value, onChange }: ChipMultiSelectProps) {
    const toggle = (option: string) =>
        onChange(value.includes(option) ? value.filter(v => v !== option) : [...value, option]);

    return (
        <div className="chip-row">
            {options.map(option => (
                <ChipToggle key={option} label={option} active={value.includes(option)} onClick={() => toggle(option)} />
            ))}
        </div>
    );
}
